import type {Direction, EnrichedAstNode} from '../../types';

export const getFlexDirection = (node: EnrichedAstNode): Direction => {
    const isFlexColumn = node.calculatedLayoutAbstraction?.flexDirection === 'column' || false;
    const flexDirection = isFlexColumn ? 'column' : 'row';

    return flexDirection;
};
